import React, { useState, useEffect } from "react";
import "./AllChannelsMonitoring.css";
import MonitoringPlayer from "../components/player/MonitoringPlayer";

export default function AllChannelsMonitoring(){
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(window.backendDomain+'/api/v1/contents/channels/all/view', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'auth-token': localStorage.getItem('token')
            }
        })
        .then(response => response.json())
        .then(json => {
            //console.log(json.data);
            if (json.status === 'OK') {
                const uniqueData = json.data.channelsList.filter((item, index, self) =>
                    index === self.findIndex((t) => (
                        t.stream_url === item.stream_url
                    ))
                );
                setData(uniqueData);
            }
        });
    }, []);

    return(
        <div className="mycontainer">
            {data.map((item, index) => (
                <MonitoringPlayer item={item} key={index} />
            ))}
        </div>
    );
}